import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';

import SendgridEventsIndex from './collection';

const SendgridEvents = ({ routes }) => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <SendgridEventsIndex />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

SendgridEvents.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
  })).isRequired,
};

export default SendgridEvents;
